var map = {
	"./alert/bg-balance.png": 7067,
	"./alert/learning.png": 6979,
	"./alert/profile-bg.png": 3468,
	"./checkout/paypal.png": 2204,
	"./details_close.png": 3441,
	"./details_open.png": 2005,
	"./ecommerce/card.png": 6633,
	"./ecommerce/mastercard.png": 9007,
	"./ecommerce/paypal.png": 6894,
	"./ecommerce/visa.png": 884,
	"./email-template/invoice-1/1.png": 1457,
	"./email-template/invoice-1/sign.png": 5249,
	"./email-template/invoice-3/bg-0.png": 4498,
	"./email-template/invoice-3/sign.png": 1007,
	"./email-template/pdfs.png": 7921,
	"./email-template/space.jpg": 6844,
	"./email-template/success.png": 6343,
	"./faq/1.jpg": 8398,
	"./faq/2.jpg": 7993,
	"./faq/3.jpg": 2732,
	"./faq/4.jpg": 2695,
	"./faq/learning-1.png": 3111,
	"./favicon/favicon.png": 879,
	"./file-manager/folder.png": 5689,
	"./file-manager/folder1.png": 1460,
	"./forms/Bank-of-Baroda.png": 6326,
	"./forms/SCB.png": 9986,
	"./forms/authenticate.png": 9159,
	"./forms/axis.png": 5287,
	"./forms/credit-card.png": 4396,
	"./forms/delivery.png": 3660,
	"./forms/email.png": 9582,
	"./forms/flags.png": 6287,
	"./forms/hdfc.png": 9493,
	"./forms/idbi.png": 3588,
	"./forms/qr-code.png": 7199,
	"./forms/qr-scan.png": 3859,
	"./forms/rbl.png": 66,
	"./forms/us-bank.png": 3245,
	"./forms/user.png": 2157,
	"./gif/danger.gif": 2467,
	"./gif/dashboard-8/successful.gif": 3378,
	"./gif/facebook.gif": 9202,
	"./gif/instagram.gif": 3462,
	"./gif/logout.gif": 2496,
	"./gif/new.gif": 3664,
	"./gif/online-shopping.gif": 8196,
	"./gif/successful.gif": 764,
	"./gif/whatapp.gif": 381,
	"./img-cropper1.jpg": 9242,
	"./js-grid.png": 7340,
	"./knowledgebase/bg_1.jpg": 8655,
	"./landing/application/1.png": 2924,
	"./landing/application/10.png": 6886,
	"./landing/application/11.png": 3215,
	"./landing/application/12.png": 8564,
	"./landing/application/2.png": 1399,
	"./landing/application/3.png": 62,
	"./landing/application/4.png": 6177,
	"./landing/application/5.png": 6232,
	"./landing/application/6.png": 3091,
	"./landing/application/7.png": 1514,
	"./landing/application/8.png": 5373,
	"./landing/application/9.png": 9220,
	"./landing/arrow-2.png": 7992,
	"./landing/arrow.png": 8889,
	"./landing/check.gif": 2973,
	"./landing/footer/shape1.png": 6026,
	"./landing/footer/shape2.png": 689,
	"./landing/footer/shape3.png": 4392,
	"./landing/footer/shape4.png": 5911,
	"./landing/footer/shape5.png": 8222,
	"./landing/footer/shape6.png": 325,
	"./landing/footer/shape7.png": 7436,
	"./landing/home.png": 6001,
	"./landing/homebg.png": 1592,
	"./landing/html.png": 7403,
	"./landing/icon/11-icon.png": 3818,
	"./landing/icon/app.png": 5199,
	"./landing/icon/bootstrap.png": 4712,
	"./landing/icon/builder.png": 3763,
	"./landing/icon/chart.png": 6861,
	"./landing/icon/css.png": 2499,
	"./landing/icon/forms.png": 3863,
	"./landing/icon/gulp.png": 6860,
	"./landing/icon/layout.png": 4830,
	"./landing/icon/npm.png": 6613,
	"./landing/icon/pug.png": 978,
	"./landing/icon/sass.png": 5878,
	"./landing/icon/starter-kit.png": 4356,
	"./landing/icon/table.png": 6494,
	"./landing/icon/ui-kits.png": 8510,
	"./landing/layout/1.png": 8498,
	"./landing/layout/2.png": 9209,
	"./landing/layout/3.png": 4384,
	"./landing/logo/footer-logo.png": 3055,
	"./landing/new.gif": 4767,
	"./landing/overview.png": 8821,
	"./landing/product.png": 8023,
	"./landing/shape-1.png": 5131,
	"./landing/support.png": 1307,
	"./login/1.jpg": 6369,
	"./login/2.jpg": 4166,
	"./login/3.jpg": 4275,
	"./login/f.jpg": 5474,
	"./login/icon.png": 1997,
	"./login/login_bg.jpg": 7665,
	"./login/login_etsdetf.png": 7756,
	"./login/loginetsdetf.png": 7018,
	"./login/logo.png": 3367,
	"./login/logo2etsdetf.png": 9024,
	"./logo.png": 2145,
	"./logo/logo-dif2.png": 9279,
	"./logo/logo_dif.png": 4015,
	"./logo/logo_dif_document.png": 4779,
	"./logo/logoetsdetf.png": 3478,
	"./logo2.png": 8631,
	"./other-images/bg-profile.png": 3887,
	"./other-images/boxbg.jpg": 138,
	"./other-images/coming-soon-bg.jpg": 1823,
	"./other-images/emoji/angry.png": 1884,
	"./other-images/emoji/love.png": 8747,
	"./other-images/emoji/sad.png": 655,
	"./other-images/emoji/smile.png": 2847,
	"./other-images/emoji/think.png": 6027,
	"./other-images/error400.svg": 784,
	"./other-images/error401.svg": 6321,
	"./other-images/error403.svg": 7827,
	"./other-images/error404.svg": 7644,
	"./other-images/error500.svg": 8041,
	"./other-images/error503.svg": 3018,
	"./other-images/img-1.jpg": 4735,
	"./other-images/img-2.jpg": 4416,
	"./other-images/img-3.jpg": 2509,
	"./other-images/img-4.jpg": 6166,
	"./other-images/img-cropper.jpg": 8697,
	"./other-images/invoice.svg": 8411,
	"./other-images/maintenance-bg.jpg": 8465,
	"./other-images/mountain.jpg": 1660,
	"./other-images/paypal.png": 3687,
	"./other-images/profile-style-img.png": 461,
	"./other-images/profile-style-img3.png": 4466,
	"./other-images/sea.jpg": 2389,
	"./other-images/sidebar-bg.jpg": 2270,
	"./profile.png": 7173,
	"./search-not-found.png": 5379,
	"./sort_asc.png": 850,
	"./sort_asc_disabled.png": 9895,
	"./sort_both.png": 3740,
	"./sort_desc.png": 5278,
	"./sort_desc_disabled.png": 979,
	"./start-conversion.jpg": 1037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4002;